// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".offer-application-info{font-size:.8rem;line-height:1.3}\n", ""]);
// Exports
module.exports = exports;
